import { render, staticRenderFns } from "./shape-minimal.vue?vue&type=template&id=5696e226&"
import script from "./shape-minimal.vue?vue&type=script&lang=js&"
export * from "./shape-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports